import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';

import { DeviceInfo, EMPTY_DEVICE_INFO } from '@core/models';

export interface DeviceState {
  device: DeviceInfo;
}

export const INITIAL_DEVICE_STATE: DeviceState = {
  device: EMPTY_DEVICE_INFO,
};

export function withDevice() {
  return signalStoreFeature(
    withState<DeviceState>(INITIAL_DEVICE_STATE),
    withMethods((store) => ({
      saveDevice: (device: DeviceInfo): void => patchState(store, { device }),
    })),
  );
}
